import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { adminApi, errMsg } from "@/lib/api";
import { toast } from "sonner";

// Recursos do Ponto ainda em homologação prática: bloqueados no servidor para todos os clientes.
// Aqui o Admin Master libera só para um cliente piloto (ex.: a loja onde está o relógio de teste), com motivo registrado.
export function PontoHomologacaoBox({ tenantId, recursos = {}, onChanged }) {
  const [motivo, setMotivo] = useState("");
  const [busy, setBusy] = useState("");
  const alterar = async (recurso, ativo) => {
    if (motivo.trim().length < 5) { toast.error("Escreva o motivo (mínimo 5 caracteres)"); return; }
    if (ativo && !window.confirm(`Liberar "${recursos[recurso]?.nome}" só para este cliente, como piloto de homologação?`)) return;
    setBusy(recurso);
    try {
      await adminApi.put(`/tenants/${tenantId}/ponto-homologacao`, { recurso, ativo, motivo: motivo.trim() });
      toast.success(ativo ? "Liberado para este cliente (piloto)" : "Bloqueado novamente");
      setMotivo(""); onChanged();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  return (
    <div className="space-y-2 border-t pt-4" data-testid="ponto-homologacao-box">
      <p className="font-semibold">Ponto: recursos em homologação</p>
      <p className="text-xs text-muted-foreground">Bloqueados para todos até a homologação com relógio e certificado reais. Libere aqui apenas para o cliente piloto do teste.</p>
      {Object.entries(recursos).map(([k, r]) => (
        <div key={k} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border px-3 py-2">
          <span>{r.nome}<span className={`ml-2 text-xs ${r.liberado ? "text-emerald-600" : "text-amber-600"}`}>
            {r.origem === "todos" ? "liberado para todos" : r.liberado ? "liberado (piloto)" : "bloqueado"}</span></span>
          {r.origem !== "todos" && (
            <Button size="sm" variant="outline" disabled={!!busy} onClick={() => alterar(k, !r.liberado)} data-testid={`ponto-homolog-${k}`}>
              {r.liberado ? "Bloquear" : "Liberar piloto"}</Button>
          )}
        </div>
      ))}
      <Input placeholder="Motivo (obrigatório): ex. teste com relógio Henry da loja matriz" value={motivo} onChange={(e) => setMotivo(e.target.value)} maxLength={300} data-testid="ponto-homolog-motivo" />
    </div>
  );
}
